import {getUrlCookieSuffix} from "@/mobile/MobileCookies";

function secureUrl(url){
    if(!window["isCordova"]){
        return url;
    }
    let suffix = getUrlCookieSuffix();
    if(url?.includes("?")){
        return url + "&" + suffix;
    }
    return url + "?" + suffix;
}

export const CordovaSessionPlugin = {
    install : function (Vue, options) {

        Vue.$secureUrl = function(url){
            return secureUrl(url);
        }

        Vue.prototype.$secureUrl = function (url) {
            return secureUrl(url);
        }
    }
}